import React from 'react';
import { ProductLineWithPrice } from '../ProductLineWithPrice';
import { AppliedSuplement } from 'services/BackendApi';
import { TCurrencyCode } from 'interfaces';
import { useCurrencyConversion } from 'context/CurrencyConversion/CurrencyConversionContext';

interface IAccommodationExtraPersonSupplementsProps {
  extraPersonSupplements: AppliedSuplement[];
  currencyCode: TCurrencyCode;
  shouldHidePricing?: boolean;
}

export const AccommodationExtraPersonSupplements: React.FC<IAccommodationExtraPersonSupplementsProps> = ({
  extraPersonSupplements,
  currencyCode,
  shouldHidePricing = false,
}) => {
  const { convert } = useCurrencyConversion();
  return (
    <>
      {extraPersonSupplements.map(supplement => {
        return (
          <div key={supplement.products[0].uuid} className="meal-plans mt-[10px]">
            <ProductLineWithPrice
              name={supplement.products.map(p => p.name).join(', ')}
              total={String(convert(supplement.total || 0))}
              totalBeforeDiscount={String(convert(supplement.totalBeforeDiscount || 0))}
              currencyCode={currencyCode}
              isOnRequest={supplement.isOnRequestOrPartiallyOnRequest}
              className="supplement"
              shouldHidePricing={shouldHidePricing}
            />
          </div>
        );
      })}
    </>
  );
};
